/* eslint-disable no-unused-vars */

import { stokpress, stokpressViewPort } from '../util/helper';
/* eslint-disable no-undef */

let Video = { refs: [] };

window.onload = function () {

	// Youtube callbacks
	window.onYouTubeIframeAPIReady = function () {
		for ( var i = 0; i < Video.iframes.length; i++ ) {
			if ( Video.iframes[i].getAttribute( 'data-source' ) !== 'youtube' ) continue;

			let player = new YT.Player( Video.iframes[i].id, {
				events: {
					'onStateChange': ( event ) => {
						if ( event.data == YT.PlayerState.PLAYING ) {
							Video.removeElement( event.target.h.parentNode.querySelectorAll( '.js-hide-on-play' ) );
							event.target.h.style.opacity = 1;
						}
					},
				},
			} )

			var playVideo = Video.iframes[i].parentNode.querySelector( '.js-playvideo' );

			if ( !playVideo ) { continue; }

			Video.refs.push( {
				player: player,
				element: Video.iframes[i],
				call: ( method ) => {
					try {
						switch ( method ) {
							case 'play':
								player.playVideo();
								player.unMute();

								break;
							case 'pause': player.pauseVideo(); break;
							case 'stop': player.stopVideo(); break;
						}
					} catch ( error ) {
						console.log( error.message );
					}
				},
			} );

			playVideo.dataset.refIndex = Video.refs.length - 1;

			playVideo.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				Video.refs[this.dataset.refIndex].call( 'play' );
			} );
		}
	};

	Video.isMobile = function () {
		return stokpress.isMobile() || stokpressViewPort.documentWidth().width < 720;
	};

	Video.initializeVimeo = function ( iframes ) {
		if ( iframes.length === 0 ) { return; }

		for ( var i = 0; i < iframes.length; i++ ) {
			if ( iframes[i].getAttribute( 'data-source' ) !== 'vimeo' ) continue;

			var playVideo = iframes[i].parentNode.parentNode.querySelector( '.js-playvideo' );

			if ( !playVideo ) { continue; }

			let player = new Vimeo.Player( iframes[i] );

			Video.refs.push( {
				player: player,
				element: player.element,
				call: ( method ) => {
					switch ( method ) {
						case 'play': player.play(); break;
						case 'pause': player.pause(); break;
						case 'stop': player.unload(); break;
					}
				},
			} );

			playVideo.dataset.refIndex = Video.refs.length - 1;

			// Fix issue not autoplaying on mobile
			const playerId = player.element.dataset.id || null;
			if (playerId && player.element && player.element.dataset.autoplay) {
				player.loadVideo(playerId).then(function(id) {
					player.play()
					player.pause()
					setTimeout(function() { player.play() }, 750)
				})
			}

			player.on( 'play', () => {
				Video.removeElement( player.element.parentNode.querySelectorAll( '.js-hide-on-play' ) );
				player.element.style.opacity = 1;
			} );

			playVideo.addEventListener( 'click', function ( event ) {
				event.preventDefault();
				Video.refs[this.dataset.refIndex].call( 'play' );
			} );
		}
	};

	Video.iframeProcess = function () {
		var includeYoutubeScript = false,
			includeVimeoScript = false;

		for ( var i = 0; i < Video.iframes.length; i++ ) {
			var source = Video.iframes[i].getAttribute( 'data-source' ),
				autoplay = Video.iframes[i].getAttribute( 'data-autoplay' );

			if ( ( !autoplay && !Video.isMobile() ) || Video.isMobile() ) {
				if ( source === 'vimeo' ) {
					includeVimeoScript = true;
				} else if ( source === 'youtube' ) {
					includeYoutubeScript = true;
				}

				if ( !autoplay || ( Video.isMobile && source === 'youtube' ) )
					Video.iframes[i].parentNode.parentNode.querySelectorAll( '.js-hide-on-play' ).forEach( ( element ) => {
						element.style.display = '';
					} );
			} else {
				Video.iframes[i].style.opacity = 1;
			}
		}

		if ( includeVimeoScript )
			stokpress.getScript( 'https://player.vimeo.com/api/player.js', function () {
				Video.initializeVimeo( Video.iframes );
			} );

		if ( includeYoutubeScript )
			stokpress.getScript( 'https://www.youtube.com/iframe_api' );
	};

	Video.removeElement = function ( elToHide ) {
		if ( !elToHide ) { return; }

		Array.prototype.forEach.call( elToHide, function ( element ) {
			element.parentNode.removeChild( element );
		} );
	};

	Video.init = function () {
		Video.iframes = document.querySelectorAll( 'iframe.js-video-iframe' );
		Video.tags = document.querySelectorAll( 'video.js-video-tag' );

		if ( Video.iframes.length ) {
			Video.iframeProcess();
		}

		if ( Video.tags.length ) {
			for ( var i = 0; i < Video.tags.length; i++ ) {
				let player = Video.tags[i];

				Video.refs.push( {
					player: player,
					element: player,
					call: ( method ) => {
						switch ( method ) {
							case 'play': player.play(); break;
							case 'pause': player.pause(); break;
							case 'stop': player.load(); break;
						}
					},
				} );

				player.addEventListener( 'play', () => {
					Video.removeElement( player.parentNode.querySelectorAll( '.js-hide-on-play' ) );
					player.style.zIndex = 1;
				} );

				if ( Video.tags[i].getAttribute( 'autoplay' ) ) {
					Video.tags[i].style.zIndex = 1;
				} else {
					// Play video upon clicking the play button
					var playVideo = player.parentNode.querySelector( '.js-playvideo' );

					if ( !playVideo ) { continue; }

					playVideo.dataset.refIndex = Video.refs.length - 1;

					playVideo.addEventListener( 'click', function ( event ) {
						event.preventDefault();
						Video.refs[this.dataset.refIndex].call( 'play' );
					} );
				}
			}
		}
	};

	Video.init();
}

window.Video = Video;


// WEBPACK FOOTER //
// ./scripts/components/video.js